import { useAuth } from '../auth'

const C = { teal: '#2B4C5E', yellow: '#F2B705', orange: '#F5A800', light: '#C7D9DB' }

export default function LoginPage() {
  const { login } = useAuth()

  return (
    <div style={{
      minHeight:      '100vh',
      display:        'flex',
      flexDirection:  'column',
      background:     `linear-gradient(135deg, ${C.teal} 0%, #1a3340 60%, #0f1f26 100%)`,
    }}>
      <div style={{ height: 4, background: `linear-gradient(90deg, ${C.yellow}, ${C.orange})` }} />

      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{
          background:   'rgba(255,255,255,0.04)',
          border:       '1px solid rgba(199,217,219,0.15)',
          borderRadius: 16,
          padding:      '56px 48px',
          width:        420,
          textAlign:    'center',
          backdropFilter: 'blur(10px)',
        }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
            <img src="/logo.jpg" alt="BNF" style={{ width: 80, height: 80, borderRadius: 12, objectFit: 'contain', background: '#fff', padding: 4 }} />
          </div>

          <div style={{ color: C.yellow, fontSize: 11, letterSpacing: 3, marginBottom: 8 }}>
            BUSINESS NEXTGEN FINANCE
          </div>
          <h1 style={{ color: '#fff', fontSize: 24, fontWeight: 700, marginBottom: 8 }}>
            Report Platform
          </h1>
          <p style={{ color: C.light, fontSize: 14, marginBottom: 40, lineHeight: 1.6 }}>
            Automated report scheduling,<br />delivery & management
          </p>

          <button
            onClick={login}
            style={{
              width: '100%', padding: '14px 24px',
              background: '#fff', color: C.teal,
              border: 'none', borderRadius: 8,
              fontSize: 15, fontWeight: 600, cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12,
            }}
            onMouseOver={e => (e.currentTarget.style.transform = 'translateY(-1px)')}
            onMouseOut={e  => (e.currentTarget.style.transform = 'translateY(0)')}
          >
            <MicrosoftIcon />
            Sign in with Microsoft
          </button>

          <p style={{ color: '#6B8A91', fontSize: 11, marginTop: 24 }}>
            BNF employees only — use your BNF Microsoft account
          </p>
        </div>
      </div>

      <div style={{ textAlign: 'center', padding: 16, color: '#6B8A91', fontSize: 11 }}>
        © {new Date().getFullYear()} Business NextGen Finance Ltd. All rights reserved.
      </div>
    </div>
  )
}

function MicrosoftIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 21 21">
      <rect x="1"  y="1"  width="9" height="9" fill="#f25022"/>
      <rect x="11" y="1"  width="9" height="9" fill="#00a4ef"/>
      <rect x="1"  y="11" width="9" height="9" fill="#7fba00"/>
      <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
    </svg>
  )
}
